module.exports = __webpack_public_path__ + "img/3.c7d6fe8b.jpg";